module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-village_jf.png?v=d6dca961";